import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import SweetAlert from 'react-bootstrap-sweetalert';

import { constants } from '../../config';
import { BillingStore } from '../../stores/BillingStore';
import { ScreenStore } from '../../stores/ScreenStore';
import { SessionStore } from '../../stores/SessionStore';
import { CheckoutStore } from '../../stores/CheckoutStore';
import { IncrementalCheckoutSummary } from '../../common/incremental-checkout-summary';
import { BillingDataForm } from '../../common/billing-data-form';
import { SimpleButton } from '../../common/simple-button';
import { Spinner } from '../../common/spinner';
import { ComplexRadioBullet } from '../../common/complex-radio-bullet';
import { PaymentStore } from './stores/PaymentStore';
import { BillingCard } from './billing-card';
import { AddressHelper } from '../../helpers/AddressHelper';
import styles from './PaymentMethodsAndBilling.css';
import bankData from '../../assets/images';

// import { CartStore } from '../../stores/CartStore';

const IPropTypes = {
  onSubmit: PropTypes.func,
};

const defaultProps = {
  onSubmit: () => { },
};

class PaymentMethodsAndBilling extends React.Component {
  static renderPaymentTopMessage(paymentType, openModalCheck) {
    return (
      <React.Fragment>
        <h4 className={styles.paymentDescription}>
          {paymentType.description}
        </h4>
        <p className={styles.paymentDetail}>
          {paymentType.detail}
        </p>
        {
          paymentType.id === 3 &&
            <button
              onClick={openModalCheck}
              className={styles.checkSpecification}
            >
              Condiciones
            </button>
        }
      </React.Fragment>
    );
  }

  static renderPaymentBankTopMessage(bank) {
    const key = String(bank.name).toLocaleLowerCase().trim().replace(/\s/g, '');
    const data = bankData(key);
    if (!data) {
      return null;
    }

    return (
      <React.Fragment>
        <h4 className={styles.paymentDescription} style={{ display: 'flex', alignItems: 'center' }}>
          <span>{data[0]}</span>
          <img
            style={{ width: 45, marginLeft: 10, height: 30 }}
            className={styles.fullPrice}
            alt={`${data[0]} - ${key}`}
            src={data[1]}
          />
        </h4>
      </React.Fragment>
    );
  }

  static renderFullPrice() {
    return (
      <p className={styles.fullPrice}>
        ${CheckoutStore.fullPriceString}
      </p>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      paymentType: null,
      bankSelected: null,
      showNewBillingDataForm: false,
      toggleBank: false,
      promptPayCheck: false,
      promptPayBank: false,
    };

    this._onBillingSelection = this._onBillingSelection.bind(this);
    this._toggleShowBillingData = this._toggleShowBillingData.bind(this);
    this._onOpenModalCheck = this._onOpenModalCheck.bind(this);
    this._onCloseModalCheck = this._onCloseModalCheck.bind(this);
    this._onOpenModalBank = this._onOpenModalBank.bind(this);
    this._onCloseModalBank = this._onCloseModalBank.bind(this);
  }

  componentDidMount() {
    BillingStore.getBillingData();
    PaymentStore.getPaymentTypes(CheckoutStore.purchaseType);
  }

  static getAddressLine(address) {
    const secondLine = AddressHelper.getAddressSecondLine(address);
    return `${address.streetName} ${secondLine}`;
  }

  static getBillingData() {
    return {
      name: SessionStore.user.tradeName ||
        `${SessionStore.user.names} ${SessionStore.user.surnames}`,
      rut: (SessionStore.user.rut || '').trim(),
      personalId: (SessionStore.user.document || '').trim(),
      address: CheckoutStore.selectedAddress ?
        PaymentMethodsAndBilling.getAddressLine(CheckoutStore.selectedAddress) : null,
      department: CheckoutStore.selectedAddress ?
        CheckoutStore.selectedAddress.department.name : null,
      locality: CheckoutStore.selectedAddress ?
        CheckoutStore.selectedAddress.cityName.name : null,
    };
  }

  _toggleShowBillingData() {
    this.setState(prevState => ({
      showNewBillingDataForm: !prevState.showNewBillingDataForm,
    }));
  }

  _setPaymentType(paymentType) {
    if (paymentType.typeReference !== 1) {
      this.setState({
        bankSelected: null,
        paymentType,
        toggleBank: false,
      });
    } else {
      this.setState({
        paymentType,
        toggleBank: true,
      });
    }
  }

  _setBankType(bank) {
    this.setState({ bankSelected: bank });
  }

  _onBillingSelection(billingData) {
    if (!this.state.paymentType) {
      return;
    }
    if (this.state.paymentType.typeReference === 1 && !this.state.bankSelected) {
      return;
    }
    // if (this.state.paymentType && this.state.paymentType.id === 4 && this.state.bankSelected
    // && localStorage.getItem('add-debit-card')
    // && localStorage.getItem('add-debit-card') === '1') {
    //   CartStore.addCreditTaxToCart();
    //   setTimeout(() => CheckoutStore.updateCheckout(), 2000);
    // }
    this.props.onSubmit(billingData, this.state.paymentType, this.state.bankSelected);
  }

  _onOpenModalCheck() {
    this.setState({
      promptPayCheck: true,
    });
  }

  _onCloseModalCheck() {
    this.setState({
      promptPayCheck: false,
    });
  }

  _onOpenModalBank(value) {
    this.setState({
      promptPayBank: value,
    });
  }

  _onCloseModalBank() {
    this.setState({
      promptPayBank: false,
    });
  }

  render() {
    return (
      <div className={styles.container}>
        {
          this.state.promptPayBank &&
          <SweetAlert
            title="Pago con Scotiabank"
            showCancel={false}
            confirmBtnText="Cerrar"
            confirmBtnCssClass={`${styles.btnAccept} ${styles.btn}`}
            onConfirm={this._onCloseModalBank}
            closeOnClickOutside={false}
            style={{
              width: '100%',
              left: 0,
              right: 0,
              maxWidth: '500px',
              margin: '0 auto',
              top: '30%',
            }}
          >
            <div style={{ textAlign: 'justify', fontSize: 14 }}>
              <b>Recordatorio:</b> en el usuario de tu cuenta Scotiabank,
              debes habilitar antes la opción Pagar / Pago de Servicios Externos.
            </div>
          </SweetAlert>
        }
        {
          this.state.promptPayCheck &&
          <SweetAlert
            title="Condiciones para pago con cheques"
            showCancel={false}
            confirmBtnText="Cerrar"
            confirmBtnCssClass={`${styles.btnAccept} ${styles.btn}`}
            onConfirm={this._onCloseModalCheck}
            closeOnClickOutside={false}
            style={{
              width: '100%',
              left: 0,
              right: 0,
              maxWidth: '500px',
              margin: '0 auto',
              top: '30%',
            }}
          >
            <div style={{ textAlign: 'justify', fontSize: 14 }}>
              <span>Si el titular del cheque es:</span>
              <br />
              <b> - Una persona</b>, deberá exhibir el documento de identidad
              y estar presente.
              <br />
              - En el caso de <b>una empresa</b>, el comprador deberá exhibir una orden de
              compra (o carta membretada) autorizándolo a realizar la compra.
              La orden deberá tener el nombre, firma y CI del firmante del cheque.
              <br />
              <br />
              <b>Nota:</b> Carlos Gutiérrez podrá rechazar el cheque sin expresión de causa y
              si el cliente no aceptara abonar en efectivo, la compra quedará
              sin efecto sin responsabilidad alguna para Carlos Gutiérrez.
            </div>
          </SweetAlert>
        }
        <h1 className={styles.title}>
          Pago y factura
        </h1>
        <div className={styles.mainContent}>
          <div className={styles.leftSection}>
            <h2 className={styles.subtitle}>
              Forma de pago
            </h2>
            <div>
              {
                !PaymentStore.paymentTypes &&
                <Spinner className={styles.spinner} />
              }
              {
                !!PaymentStore.paymentTypes &&
                PaymentStore.paymentTypes
                  .filter((paymentType) => {
                    if (paymentType.id === 6 && (!localStorage.getItem('add-debit-card') || localStorage.getItem('add-debit-card') === '0')) {
                      return false;
                    }
                    return true;
                  })
                  .filter((paymentType) => {
                    if (paymentType.typeReference === 1) {
                      // eslint-disable-next-line no-prototype-builtins
                      if (!SessionStore.user.hasOwnProperty('canNoPayWithBank')) {
                        return false;
                      }
                      return !SessionStore.user.canNoPayWithBank;
                    }
                    return true;
                  })
                  .filter((paymentType) => {
                    if (!CheckoutStore.selectedOption ||
                      CheckoutStore.selectedOption.acceptedPaymentMethods
                      .includes(paymentType.id)) {
                        return true;
                    }
                    return false;
                  })
                  .map((paymentType) => {
                    const selected = !!this.state.paymentType &&
                      paymentType.id === this.state.paymentType.id;
                    return (
                      <Fragment key={`f-${paymentType.id}`}>
                        <ComplexRadioBullet
                          key={paymentType.id}
                          onClick={() => this._setPaymentType(paymentType)}
                          rightContent={PaymentMethodsAndBilling.renderFullPrice()}
                          selected={selected}
                          topMessage={
                            PaymentMethodsAndBilling
                            .renderPaymentTopMessage(paymentType, this._onOpenModalCheck)
                          }
                        />
                        {
                          paymentType.typeReference === 1 && this.state.toggleBank &&
                          <div style={{ paddingLeft: 45, marginTop: 10, marginBottom: 10 }}>
                            {
                              paymentType.references
                              .map(item => (
                                <div key={item.id}>
                                  <ComplexRadioBullet
                                    onClick={() => {
                                      this._setBankType(item);
                                      this._onOpenModalBank(item && item.code === '128');
                                    }}
                                    selected={this.state.bankSelected &&
                                      this.state.bankSelected.id === item.id}
                                    topMessage={
                                      PaymentMethodsAndBilling.renderPaymentBankTopMessage(item)
                                    }
                                  />
                                </div>
                              ))
                            }
                          </div>
                        }
                      </Fragment>
                    );
                  })
              }
            </div>
            {/* <div style={{ fontSize: 12 }}>
              <i>*Aplica adicional $25 y se descuenta 2% del IVA</i>
            </div> */}
            <h2 className={styles.subtitle}>
              Datos de facturación
            </h2>
            <p className={styles.text}>
              Es importante que los verifiques:
              <br />
              · para la garantía
              <br />
              · porque después no podremos cambiar la factura
            </p>
            {
              !BillingStore.billingData &&
              <Spinner className={styles.spinner} />
            }
            {
              !!BillingStore.billingData &&
              BillingStore.billingData.length > 0 &&
              <div className={styles.billingContainer}>
                {BillingStore.billingData.map(billing => (
                  <BillingCard
                    billing={billing}
                    disabled={!this.state.paymentType ||
                      (this.state.paymentType.typeReference === 1 &&
                      !this.state.bankSelected)}
                    key={billing.id}
                    onClick={() => this._onBillingSelection(billing)}
                  />
                ))}
              </div>
            }
            {
              !!BillingStore.billingData &&
              !BillingStore.billingData.length &&
              <p className={styles.message}>
                No tienes datos de facturación creados, por favor crea unos antes de continuar.
              </p>
            }
            {
              !this.state.showNewBillingDataForm &&
              <SimpleButton
                className={styles.btnNewInfo}
                disabled={!this.state.paymentType ||
                  (this.state.paymentType.typeReference === 1 &&
                  !this.state.bankSelected)}
                onClick={this._toggleShowBillingData}
              >
                Nueva información de facturación
              </SimpleButton>
            }
            {
              this.state.showNewBillingDataForm &&
              <BillingDataForm
                buttonText="Utilizar estos"
                onSubmit={this._onBillingSelection}
                billing={!!BillingStore.billingData && !BillingStore.billingData.length ?
                   PaymentMethodsAndBilling.getBillingData() : null}
              />
            }
          </div>
          {
            ScreenStore.screenWidth > constants.breakpoints.smallMaxWidth &&
            <div className={styles.summarySection}>
              <IncrementalCheckoutSummary />
            </div>
          }
        </div>
      </div>
    );
  }
}

PaymentMethodsAndBilling.propTypes = IPropTypes;
PaymentMethodsAndBilling.defaultProps = defaultProps;

const ObservedPaymentMethodsAndBilling = observer(PaymentMethodsAndBilling);

export { ObservedPaymentMethodsAndBilling as PaymentMethodsAndBilling };



// WEBPACK FOOTER //
// ./src/pages/payment-methods-and-billing/PaymentMethodsAndBilling.jsx